import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { DeliverynoteModel } from './deliverynote.model';
import { ContactModel } from '../../contact/contact/contact.model';
import { InvoiceLineModel } from './invoiceline.model';
import { InvoiceTaxModel } from './invoicetax.model';
import { AccountsAndTaxesModel } from './accountsandtaxes.model';
import { EventEmitter } from '@angular/core';
import { Output, AfterContentChecked } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { BankAccountModel } from '../../finanzas/bancos/bankaccount.model';
import { InvoiceTaxesModel } from './invoicetaxes.model';
import { Observable } from 'rxjs';
import { TaxCalculator } from '../../../shared/taxCalculator';
import { UserCompanyModel } from '../../user/usercompany/usercompany.model';
import { AccountingModel } from '../../user/accountingModel/accountingModel.model';
import { AccountingModelService } from '../../user/accountingModel/accountingModel.service';
import { Utils, DatesCF, ActualSelected } from '../../../shared/utils';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { consts, BILL_METHODS } from '../../../consts';
import moment from 'moment';
import { AccountModel } from '../preinvoice/account.model';
import { ContactService } from '../../contact/contact/contact.service';
import { GetUserInfo } from '../../../shared/utils';
import { ConceptModel } from '../../concept/concept/concept.model';
import { UserStockService } from '../../user/userStock/userStock.service';
import { ConceptContactModel } from '../../concept/conceptcontact/conceptcontact.model';
import { CenterModel } from '../../contact/center/center.model';
import { ConceptContactService } from '../../concept/conceptcontact/conceptcontact.service';
import { CenterService } from '../../contact/center/center.service';
import { DeliveryNoteService } from './deliverynote.service';
import { Efectivo } from '../../../models/finanzas/efectivo/efectivo.model';
import { EfectivoService } from '../../../services/finanzas/efectivo/efectivo.service';
import { PartnersService } from '../../user/partnersequity/partners/partners.service';
import { PartnersModel } from '../../user/partnersequity/partners/partners.model';
import { DeliveryNoteFormItemComponent } from './deliverynote-form-item.component';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { ContactFormV2Component } from '../../../modules_v2/contacts/components/contact-form-v2/contact-form-v2.component';
import { MasterModel } from '../../../modules_v2/master/models/master.model';
import { MasterService } from '../../../modules_v2/master/services/master.service';
import { ActivityService } from '../../user/activity/activity.service';
import { SupplierToWhomIOweTheMostModel } from '../../statistics/statistics.model';
import { map, delay } from 'rxjs/operators';
import { Option } from '../../../shared/models/option.model';

@Component({
    selector: 'convfact-deliverynote-form',
    templateUrl: './deliverynote-form.component.html',
    styleUrls: ['./deliverynote.component.css'],
    standalone: false
})

export class DeliveryNoteFormComponent implements OnInit, AfterContentChecked {
  @Input() concepts = Array<ConceptModel>();
  @Input() deliverynote: DeliverynoteModel;
  @Input() accountsAndTaxes: AccountsAndTaxesModel;
  @Input() contacts: ContactModel[] = [];
  @Input() bankAccounts: BankAccountModel;
  @Input() userCompany: UserCompanyModel;
  @Input() accountings: AccountingModel[] = [];

  @Output() onSave = new EventEmitter<any>();

  @Input() errors: object;

  ready = false;
  haveStock = GetUserInfo.haveStock;
  contactPreinvoiceOK = false;

  aux: number;
  result: number;
  taxes: Array<InvoiceTaxModel>;
  taxesView: string[] = [];

  expenseCtrl: UntypedFormControl;
  filteredExpenses: Observable<any[]>;
  expenseList: any[] = [];

  entranceCtrl: UntypedFormControl;
  filteredEntrances: Observable<any[]>;
  entranceList: any[] = [];

  accountAndTaxesList = new AccountsAndTaxesModel;

  taxesInvoice: InvoiceTaxesModel[] = [];
  taxesToTheView: string[] = [];

  billMethods = [
    { id: consts.TYPEPAY_CASH, data: consts.TYPEPAY_CASH },
    { id: consts.TYPEPAY_SEPA, data: consts.TYPEPAY_SEPA },
    { id: consts.TYPEPAY_BANKTRANSFERENCE, data: consts.TYPEPAY_BANKTRANSFERENCE },
    { id: consts.TYPEPAY_CONFIRMING, data: consts.TYPEPAY_CONFIRMING },
    { id: consts.TYPEPAY_PAGARES, data: consts.TYPEPAY_PAGARES },
    { id: consts.TYPE_TARJETA, data: consts.TYPE_TARJETA },
    { id: consts.TYPE_SOCIO, data: consts.TYPE_SOCIO },
  ];

  payMethodCtrl: UntypedFormControl;
  filteredPayMethod: Observable<any>;

  contactSelected: ContactModel;
  rates: ConceptContactModel[] = [];
  centers: CenterModel[] = [];
  projects: MasterModel[] = [];
  isProjectEnable: boolean = false;

  public showNumberKilometer: boolean = false;

  public get centerOptions(): Option[] {
    return [
      { label: 'Seleccionar', value: '00000000-0000-0000-0000-000000000000' },
      ...this.centers.map(c => ({ label: c.code + ' - ' + c.name, value: c.uid }))
    ];
  }

  public efectivoList: Efectivo[] = [];
  public sociosList: PartnersModel[] = [];

  public saved: boolean = false;

  public contactList: ContactModel[] = [];
  public newContactLoaded = new BehaviorSubject<boolean>(true);

  constructor(
    public snackBar: MatSnackBar,
    private contactService: ContactService,
    private taxCalculator: TaxCalculator,
    private accountingModelService: AccountingModelService,
    private userStockService: UserStockService,
    public dialog: MatDialog,
    private conceptContactService: ConceptContactService,
    private centerService: CenterService,
    private cdr: ChangeDetectorRef,
    private deliverynoteService: DeliveryNoteService,
    private efectivoService: EfectivoService,
    private partnersService: PartnersService,
    private masterService: MasterService,
    private activityService: ActivityService
  ) { }

  displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, 'Cerrar', options);
  }

  toggleUseDeliverAddress(event: MatCheckboxChange) {
    if (!this.contactSelected || !this.contactSelected.deliverAddress || this.contactSelected.deliverAddress.trim() === '') {
      this.displayInfo(
        "El contacto seleccionado no dispone de domicilio de entrega, puede cumplimentarlo en la ficha Cliente en Contactos."
      );

      this.deliverynote.useDeliverAddress = false;
      event.source.checked = false;
      return;
    }

    this.deliverynote.useDeliverAddress = event.checked;
  }

  onConditionsChange(event: MatCheckboxChange) {
    this.deliverynote.conditions = event.checked;
    this.deliverynote.noConditions = !event.checked;
  }

  filterPayMethod(val) {
    const self = this;
    for (const method of this.billMethods) {
      if (method === val) {
        self.deliverynote.typePay = method.id;
      }
    }

    return val ? this.billMethods.filter(s => s.id.toLowerCase().indexOf(val.toLowerCase()) === 0)
      : this.billMethods;
  }

  filterEntrances(val) {
    const self = this;
    for (const account of this.entranceList) {
      if (account.number === val) {
        self.deliverynote.entranceAccount = account.number;
      }
    }

    return val ? this.entranceList.filter(s => s.number.toLowerCase().indexOf(val.toLowerCase()) === 0)
      : this.entranceList;
  }

  filterExpenses(val) {
    const self = this;
    for (const account of this.expenseList) {
      if (account.number === val) {
        self.deliverynote.expenseAccount = account.number;
      }
    }

    return val ? this.expenseList.filter(s => s.number.toLowerCase().indexOf(val.toLowerCase()) === 0)
      : this.expenseList;
  }

  // Normaliza la cadena eliminando diacríticos y convirtiéndola a minúsculas
  // NFD Descompone la consonante por ejemplo ñ -> n -> ~
  private normalize(str: string): string {
    return str.normalize('NFD').replace(/[\u0300\u0301\u0303\u0327\u0308]/g, '').toLowerCase();
  }




  restoreRates() {
    if (this.rates.length > 0 && this.deliverynote.invoiceLines.length > 0) {
      this.deliverynote.invoiceLines.forEach(element => {
        const rate = this.rates.find(f => f.conceptUid == element.conceptUid);
        if (rate != null && rate.price != null) {
          element.unityAmount = element.netPrice;
        }
        element.conceptCode = null;
      });
    }

    this.rates = [];
    this.centers = [];
  }

  checkRates() {
    if (this.deliverynote.receiverUid != null && this.rates.length > 0 && this.deliverynote.invoiceLines.length > 0) {
      this.deliverynote.invoiceLines.forEach(element => {
        const rate = this.rates.find(f => f.conceptUid == element.conceptUid);
        if (rate != null && rate.price != null) {
          element.unityAmount = rate.price;
          element.conceptCode = rate.conceptCode;
        }
      });
    }
  }


  assignContactUid(contactUid) {
    this.contactPreinvoiceOK = true;

    this.restoreRates();

    // this.conceptContactService.getListByContact(contactUid).then(data => {
    //     this.rates = data;
    //     this.checkRates();
    // });

    this.centerService.getListByContact(contactUid).then(data => {
      this.centers = data;
      this.cdr.detectChanges();
    });

    this.ready = true;
  }


  ngOnInit() {
    if (ActualSelected.iaeIdHeading === consts.IAE_ID_VEHICLES) {
      this.showNumberKilometer = true;
    }
    this.activityService.loadData(ActualSelected.activitySelected).then(activity => {
      this.isProjectEnable = activity.isProject;
    });

    this.efectivoService.list()
      .then(listadoEfectivos => {
        this.efectivoList = listadoEfectivos
      });

    this.partnersService.list()
      .then(response => {
        this.sociosList = response
      });
    //Projects

    this.masterService.getProjects().subscribe(data => {
      this.projects = data;
      this.cdr.detectChanges();
    })

    this.contactService.getListClients().then(response => {
      this.contactList = response;
    }).catch(err => {
      this.newContactLoaded.next(true);
      this.displayInfo('Ha ocurrido un error inesperado al obtener el listado de contactos');
    });

    this.payMethodCtrl = new UntypedFormControl();
    this.filteredPayMethod = this.payMethodCtrl.valueChanges
      .pipe(map(method => this.filterPayMethod(method)));

    this.accountingModelService.getList('ingreso').then(data => {
      data.forEach(account => {
        if (Utils.AccountIsForIncomes(account.type)) {
          const temp: AccountModel = new AccountModel();
          temp.name = account.name;
          temp.number = account.number;
          temp.type = account.type;
          this.entranceList.push(temp);
        }
      });
    });

    this.entranceCtrl = new UntypedFormControl();
    this.filteredEntrances = this.entranceCtrl.valueChanges
      .pipe(
        map(account => account && typeof account === 'object' ? account.number : account),
        map(name => this.filterEntrances(name))
      );

    if (this.deliverynote.receiverUid != null && this.deliverynote.receiverUid != undefined) {
      this.assignContactUid(this.deliverynote.receiverUid);
      this.contactService.loadData(this.deliverynote.receiverUid).then(response => {
        this.contactSelected = response;
      });
    } else {
      this.ready = true;
    }
  }

  ngAfterContentChecked() {
    this.taxesView.length = 0;
    this.taxesToTheView.length = 0;
    this.taxesInvoice.length = 0;
    this.taxCalculator.calcularSubtotal(this.deliverynote);
    this.taxCalculator.calcularTotal(this.deliverynote);
    this.taxesToTheView = this.taxCalculator.impuestos(this.deliverynote, this.result, this.aux, this.taxesView, this.taxesInvoice, this.taxesToTheView);
    this.checkRates();
  }

  calcularSubtotal() {
    return this.taxCalculator.calcularSubtotal(this.deliverynote);
  }

  calcularTotal() {
    this.deliverynote.total = this.taxCalculator.calcularTotal(this.deliverynote);
    return this.deliverynote.total;
  }

  impuestos() {
    this.taxesToTheView = this.taxCalculator.impuestos(this.deliverynote, this.result, this.aux, this.taxesView, this.taxesInvoice, this.taxesToTheView);
    return this.taxesToTheView;
  }

  save(deliverynote) {
    let noError = true;

    if (!Utils.DateIsInFiscalYear(deliverynote.invoiceRelease)) {
      noError = false;
      this.displayInfo("La fecha de creación y el año fiscal seleccionado, no son el mismo.");
    }

    if (deliverynote.entranceAccount == null || deliverynote.entranceAccount == "") {
      noError = false;
      this.displayInfo("Debe especificar la cuenta contable de ingreso.");
    }

    //if (deliverynote.typePay == null || deliverynote.typePay == "") {
    //  noError = false;
    //  this.displayInfo("Debe especificar el tipo de cobro.");
    //}

    if ((deliverynote.typePay == consts.TYPEPAY_BANKTRANSFERENCE ||
      deliverynote.typePay == consts.TYPEPAY_SEPA ||
      deliverynote.typePay == consts.TYPE_TARJETA ||
      deliverynote.typePay == consts.TYPEPAY_CONFIRMING ||
      deliverynote.typePay == consts.TYPEPAY_PAGARES) &&
      (deliverynote.typePayBankAccount == null || deliverynote.typePayBankAccount == "")) {
      noError = false;
      this.displayInfo("Debe especificar la cuenta bancaria.");
    }

    if (deliverynote.numberKilometers == null || deliverynote.numberKilometers === '') {
      deliverynote.numberKilometers = null;
    }
    if (deliverynote.numberKilometers > 9999999.99) {
      noError = false;
      this.displayInfo("El campo 'Número de kilometros' no puede ser superior 9 999 999.99");
    }

    if (deliverynote.typePay !== consts.TYPEPAY_CASH) {
      deliverynote.efectivoId = null;
    }

    if (deliverynote.typePay !== consts.TYPE_SOCIO) {
      deliverynote.partnersId = 0;
    }

    // Controlamos que todas las lineas de base tengan impuestos
    const invoiceLinesHaveTaxes: string = this.invoiceLinesHaveTaxes(deliverynote);

    if (!Utils.IsNullOrEmpty(invoiceLinesHaveTaxes)) {
      this.displayInfo(invoiceLinesHaveTaxes);
      return;
    }

    if (noError) {
      deliverynote.projectUid = this.deliverynote.projectUid;
      this.deliverynoteService.saveRequestUpdateValue(true);
      this.preventNullOrEmptyValues(deliverynote);
      this.onSave.emit(deliverynote);
    }
  }

  private invoiceLinesHaveTaxes(preinvoice: any): string {

    if (preinvoice.invoiceLines) {

      for (let i = 0; i < preinvoice.invoiceLines.length; i++) {

        if (preinvoice.invoiceLines[i].taxes && preinvoice.invoiceLines[i].taxes.length === 0) {
          return 'Compruebe que todos sus conceptos incluyan al menos un impuesto';
        }

        if (preinvoice.invoiceLines[i].taxes && !preinvoice.invoiceLines[i].taxes.find(x => (x.type === 'IVA' || x.type === 'IGIC'))) {
          return 'Incluya al menos un impuesto indirecto (IVA o IGIC) en cada concepto';
        }

      }

    }

    return '';
  }

  preventNullOrEmptyValues(deliverynote) {
    for (let i = 0; i < deliverynote.invoiceLines.length; i++) {

      if (deliverynote.invoiceLines[i].discount == null || deliverynote.invoiceLines[i].discount === '') {
        deliverynote.invoiceLines[i].discount = 0;
      }
      if (deliverynote.invoiceLines[i].quantity == null || deliverynote.invoiceLines[i].quantity === '') {
        deliverynote.invoiceLines[i].quantity = 0;
      }
      if (deliverynote.invoiceLines[i].unityAmount == null || deliverynote.invoiceLines[i].unityAmount === '') {
        deliverynote.invoiceLines[i].unityAmount = 0;
      }

    }
  }

  changeToggle(element, other) {
    this.deliverynote[other] = (this.deliverynote[element]);
  }

  setExpiration(event: MatDatepickerInputEvent<Date>) {
    let auxDate = new Date();
    auxDate = event.value;
    if (this.deliverynote.receiverName != null) {
      const contactSelected = this.contacts.find(f => f.companyName == this.deliverynote.receiverName)

      if (auxDate != null && contactSelected != null &&
        contactSelected.expirationClient != null &&
        DatesCF.toDate(auxDate.toLocaleDateString()).valid) {
        this.deliverynote.invoiceRelease = auxDate;
        this.deliverynote.invoiceExpiration = new Date(moment(auxDate).add(contactSelected.expirationClient, 'days').toDate());
      }
    }
  }


  addInvoiceLine() {
    let line = new InvoiceLineModel();

    if (this.contactSelected && this.contactSelected.taxClientUid != null) {
      const tax: InvoiceTaxModel = this.accountsAndTaxes['taxes'].find(x => x.uid === this.contactSelected.taxClientUid);
      line.taxes.push(tax);
    }
    if (this.contactSelected && this.contactSelected.taxClientSecondUid != null) {
      const tax: InvoiceTaxModel = this.accountsAndTaxes['taxes'].find(x => x.uid === this.contactSelected.taxClientSecondUid);
      line.taxes.push(tax);
    }

    const dialog = this.dialog.open(DeliveryNoteFormItemComponent, {
      data: { taxes: this.accountsAndTaxes.taxes, item: line },
    }).afterClosed().subscribe(result => {
      if (result && result.action === 'save') {
        line = result.item;
        line.position = this.deliverynote.invoiceLines.length;
        this.deliverynote.invoiceLines.push(line);
      }
      this.cdr.detectChanges();
    });
  }

  removeInvoiceLine(invoiceLine) {
    this.deliverynote.invoiceLines.splice(this.deliverynote.invoiceLines.indexOf(invoiceLine), 1);
  }

  toggleEditMode(index) {
    const dialog = this.dialog.open(DeliveryNoteFormItemComponent, {
      data: { taxes: this.accountsAndTaxes.taxes, item: this.deliverynote.invoiceLines[index] },
    }).afterClosed().subscribe(result => {
      if (result && result.action === 'save') {
        this.deliverynote.invoiceLines[index] = result.item;
      } else {

      }
      this.cdr.detectChanges();
    });

  }

  calcularTotalesLinea(invoiceLine) {
    invoiceLine.totalLine = this.taxCalculator.calcularTotalLinea(invoiceLine);
    return invoiceLine.totalLine;
  }

  saveLine(index, item) {
    this.deliverynote.invoiceLines[index] = item;
  }

  getStrTaxes(taxes: any[]) {
    if (taxes != null) {
      if (taxes.length > 0 && taxes[0] != null) {
        return taxes.map(tax => tax.name).join(', ');
      }
    }
  }

  public newContact(isExpense: boolean): void {
    const contactScratch = new ContactModel();

    if (isExpense === false) {
      contactScratch.isProvider = false;
      contactScratch.isClient = true;
    }

    contactScratch.isPhysical = true;

    const dialogNewContact = ContactFormV2Component.open(this.dialog, { scratch: contactScratch });

    this.newContactLoaded.next(false);

    dialogNewContact
      .pipe(
        map(value => {
          if (value === undefined) {
            this.newContactLoaded.next(true);
          }
          return value;
        }),
        delay(1200)
      )
      .subscribe(result => {
        if (result !== undefined) {
          this.contactService.getListClients().then(response => {
            if (response.length == this.contactList.length) {
              this.contactList = response;
              this.newContactLoaded.next(null);
            } else {
              this.contactList = response;
              this.newContactLoaded.next(true);
            }
          }).catch(() => {
            this.newContactLoaded.next(true);
            this.displayInfo('Ha ocurrido un error inesperado al obtener el listado de contactos');
          });
        }
      });
  }

  public onSelectContact(companyName): void {
    const contact = this.contactList.filter(c => c.companyName == companyName)[0];
    this.deliverynote.receiverUid = contact.uid;

    this.contactService.loadData(this.deliverynote.receiverUid).then(response => {
      this.contactSelected = response;

      this.deliverynote.entranceAccount = response.entranceAccount;
      this.deliverynote.expenseAccount = response.expenseAccount;

      let account = null;
      if (Utils.IsNullOrEmpty(this.deliverynote.entranceAccount)) {
        if (this.userCompany.isSalesInvoice) {
          account = this.entranceList.filter(c => c.number == '7000000001')[0];
        }

        if (this.userCompany.isServiceInvoice) {
          account = this.entranceList.filter(c => c.number == '7050000001')[0];
        }

        if (this.userCompany.isSalesInvoice && this.userCompany.isServiceInvoice) {
          account = this.entranceList.filter(c => c.number == '7000000001')[0];
        }
      } else {
        account = this.entranceList.filter(c => c.number == response.entranceAccount)[0];
      }

      if (account) {
        this.deliverynote.entranceAccount = account.number + ' - ' + account.name;
      }

      this.deliverynote.typePay = response.paymentTypeClient;

      const line = new InvoiceLineModel();
      line.discount = 0;
      line.position = 0;
      line.product = "";
      line.quantity = 0;
      line.totalLine = 0;
      line.unityAmount = 0;
      line.position = this.deliverynote.invoiceLines.length;

      if (this.contactSelected.paymentClientUid != null) {
        this.deliverynote.typePayBankAccount = response.paymentClientUid;
      }
      if (this.contactSelected.clientEfectivoId != null) {
        this.deliverynote.efectivoId = response.clientEfectivoId;
      }
      if (this.contactSelected.clientPartnersId != null) {
        this.deliverynote.partnersId = response.clientPartnersId;
      }

      if (this.contactSelected.expirationClient == null) {
        const expiration = new Date();
        this.deliverynote.invoiceExpiration = expiration;
      }
      else {
        if (this.contactSelected != null && this.contactSelected.expirationClient != null && DatesCF.toDate(this.deliverynote.invoiceRelease.toLocaleDateString()).valid) {
          this.deliverynote.invoiceExpiration = new Date(moment(this.deliverynote.invoiceRelease).add(this.contactSelected.expirationClient, 'days').toDate());
        }
      }

    });
    this.assignContactUid(contact.uid)
  }
  public trackByIndex(i: number) { return i; }

}
